(() => {
  if (customElements.get('product-subscription')) {
    return;
  }

  class ProductSubscription extends HTMLElement {
    static LOADED_CLASS = 'is-loaded';

    constructor() {
      super();

      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.addEventListener('change', this.onChange);
    }

    detachEvents() {
      this.removeEventListener('change', this.onChange);
    }

    init() {
      if (!window.ReChargeWidget) {
        this.waitForRechargeWidget();

        return;
      }

      this.productId = this.dataset.productId;
      this.formId = this.dataset.form;
      this.form = document.querySelector(`form[id="${this.formId}"]`);
      this.sellingPlanField = this.form?.querySelector(
        'input[name="selling_plan"]',
      );

      if (!this.sellingPlanField && this.form) {
        this.sellingPlanField = document.createElement('input');

        this.sellingPlanField.type = 'hidden';
        this.sellingPlanField.name = 'selling_plan';
        this.sellingPlanField.value = '';

        this.form.appendChild(this.sellingPlanField);
      }

      this.productSelector = document.querySelector(
        `product-selector[data-form-id="${this.formId}"], main-product-selector[data-form-id="${this.formId}"]`,
      );

      window.ReChargeWidget.createWidget({
        productId: this.dataset.productId,
        injectionParent: this,
      });

      this.classList.add(ProductSubscription.LOADED_CLASS);

      this.attachEvents();
    }

    onChange() {
      if (!this.sellingPlanField) {
        return;
      }

      const activeInput = this.querySelector('input:checked');

      if (activeInput.value === 'onetime') {
        this.clearSellingPlan();
      } else {
        const sellingPlanId =
          this.querySelector('select[name="selling_plan"]')?.value || '';
        this.setSellingPlan(sellingPlanId);
      }

      this.productSelector.dispatchEvent(new CustomEvent('change'));
    }

    clearSellingPlan() {
      this.sellingPlanField.value = '';
    }

    setSellingPlan(sellingPlanId) {
      this.sellingPlanField.value = sellingPlanId;
    }

    waitForRechargeWidget() {
      const interval = setInterval(() => {
        if (window.ReChargeWidget) {
          clearInterval(interval);

          this.init();
        }
      }, 100);
    }
  }

  customElements.define('product-subscription', ProductSubscription);
})();
